/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockPositemlinkCtrl
 */
angular.module('mercury.modules.stock.positemlink')
.controller('StockPositemlinkCtrl', ["dialog", "$filter", "ReportPosItems", "$resource", "$q", "$scope", "$state", "$stateParams", "StockItems", "StockRecipes", "StockUnits", "title", "settings", "userinfo", function(dialog, $filter, ReportPosItems, $resource, $q, $scope, $state, $stateParams,
    StockItems, StockRecipes, StockUnits, title, settings, userinfo) {
  title.set('Manage Pos Item Links');

  var PosItemLink = $resource(settings.apiHost + '/r/StockPositemLinks/:id', {id: '@id'});

  $scope.isCloudposCompany = userinfo.companyPos() === 'Cloudpos';

  //Resource Load
  var stockItemOptions = StockItems.getAllActive();
  var recipeOptions = StockRecipes.getAllActive();
  $scope.units = StockUnits.getAllActive();

  var posItems = ReportPosItems.getAll();
  posItems.then(function(result) {
    posItems = result;
  });

  var posLinks = PosItemLink.query();

  $scope.$on('$stateChangeSuccess', function(event, toState, toStateParams) {
    title.set('Manage Pos Item Links');

    if ($state.current.name == 'Stock.PosItemLink') {
      $state.go('Stock.PosItemLink.Suggestions');
    }

    if (toStateParams.groupName) {
      $scope.activeGroup = toStateParams.groupName;
    }
  });

  $scope.initalLoadPromise = $q.all([
    posItems,
    stockItemOptions.$promise,
    recipeOptions.$promise,
    $scope.units.$promise,
    posLinks.$promise
  ]);

  $scope.initalLoadPromise.then(function() {
    $scope.linkOptions = [];

    angular.forEach(stockItemOptions, function(item) {
      $scope.linkOptions.push({
        name: item.name,
        id: item.id,
        group: item.groupName,
        unitId: item.countingUnitId,
        unitName: item.countingUnitName,
        unitRatio: item.countingUnitRatio,
        currentPrice: item.currentPrice
      });
    });

    angular.forEach(recipeOptions, function(recipe) {
      $scope.linkOptions.push({
        name: recipe.name,
        id: recipe.id,
        group: 'Recipes',
        unitId: recipe.currentVersionYeildUnitId,
        unitName: recipe.currentVersionYeildUnitName,
        unitRatio: recipe.currentVersionYeildUnitRatio,
        currentPrice: recipe.currentPrice
      });
    });

    //Loop through all item groups and show only the group in displayedGroups object
    var groups = [];
    var activePosItems = [];
    angular.forEach(posItems, function(item) {
      item.history = $filter('filter')(posLinks, function(posLink) {
        return posLink.posIdentifier == item.posIdentifier;
      });
      item.currentLink = $scope.findCurrentLink(item.history);

      // If the POS item is deleted and there is no current link, hide the POS item.
      if (item.whenDeleted && (item.history.length === 0 || !item.currentLink.stockId)) {
        return;
      }

      if (item.itemGroupName !== null && groups.indexOf(item.itemGroupName) == -1) {
        groups.push(item.itemGroupName);
      }

      if (item.itemCategoryName !== null && groups.indexOf(item.itemCategoryName) == -1) {
        groups.push(item.itemCategoryName);
      }

      if (item.revenueGroup !== null && groups.indexOf(item.revenueGroup) == -1) {
        groups.push(item.revenueGroup);
      }

      activePosItems.push(item);
    });

    $scope.groups = $filter('orderBy')(groups);
    $scope.posItems = activePosItems;
  });

  $scope.findCurrentLink = function(links) {
    var currentLink = {quantity: 0};
    angular.forEach(links, function(link) {
      if (link.validFrom === null || moment(link.validFrom).isBefore()) {
        currentLink = angular.copy(link);
      }
    });
    return currentLink;
  };

  $scope.linkUpdated = function(link, saveNew) {
    var savePromise;

    // If the currrent link was updated in the last day, don't create a new PosItemLink entry, just update the current one.
    if (link.deleted) {
      savePromise = PosItemLink.delete({}, link).$promise;
    } else if (saveNew) {
      delete link.id;
      link.validFrom = moment().format();
      savePromise = PosItemLink.save(link).$promise;
    } else {
      link.datestampUpdated = moment().format();
      savePromise = PosItemLink.update(link).$promise;
    }

    savePromise.then(function(response) {
      angular.forEach($scope.posItems, function(posItem) {
        if (posItem.posIdentifier == link.posIdentifier) {
          posItem.pending = false;

          if (!link.id) {
            posItem.history.push(response);
          } else {
            angular.forEach(posItem.history, function(history, index) {
              if (history.id == link.id) {
                if (link.deleted) {
                  posItem.history.splice(index, 1);

                  if (posItem.history.length > 0) {
                    posItem.history[0].validFrom = null;
                  }
                } else {
                  posItem.history.splice(index, 1, link);
                }
              }
            });
          }

          // Ensure the history is still ordered by validFrom.
          posItem.history = $filter('orderBy')(posItem.history, function(link) {
            return (link.validFrom === null) ? 0 : moment(link.validFrom).unix();
          });

          posItem.currentLink = $scope.findCurrentLink(posItem.history);
        }
      });
    });

    return savePromise;
  };
}]);
